<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Breadcrumbs main="Auditor Reports" title="default" />
  <div class="container-fluid p-0">
    <div class="row widget-grid">
      <div class="row widget-grid m-0 mt-2 p-0">
        <div class="m-0 py-0">
          <el-row>
            <el-col :span="filterButtonOpenClose || $vuetify.display.width < 450 ? 24 : 8">
              <div class="pl-0">
                <FilterS2
                  :period-name-prop="'Current MP'"
                  :for-verra-or-auditor-reports="true"
                  @filterHandle="filterHandle"
                  @buttonOpenClose="buttonOpenClosehandle"
                />
              </div>
            </el-col>
            <el-col
              class="p-0"
              :span="filterButtonOpenClose || $vuetify.display.width < 450 ? 24 : 16"
              :class="
                $vuetify.display.width < 450
                  ? 'pr-1 order-1 width-100-p d-flex x-end'
                  : 'd-flex justify-content-end'
              "
            >
              <div class="d-flex justify-content-end verra-report-button-wrapper m-r-10">
                <el-button
                  color="#ddf0ac"
                  class="height-40 border-color-light mr-1 rounded-3"
                  @click="handleClearCache"
                >
                  <svg class="stroke-icon width-20 height-20">
                    <use href="@/assets/svg/icon-sprite.svg#stroke-refresh"></use>
                  </svg>
                  <span class="moderat-btn-apply pl-3"> Refresh Cache </span>
                </el-button>

                <el-button
                  class="new-download-file-btn new-button-behavior"
                  @click.stop="handleExportFile"
                >
                  <svg class="width-40 height-40">
                    <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                  </svg>
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <el-row
        v-loading="auditorPageLoading"
        class="m-0 width-100-p"
        :class="
          $vuetify.display.width >= 1400
            ? 'mb-30'
            : $vuetify.display.width >= 768
              ? 'mb-30'
              : $vuetify.display.width >= 375
                ? 'mb-24'
                : 'mb-20'
        "
      >
        <el-col class="d-flex align-item-center" :span="24">
          <div class="row m-0 width-100-p">
            <div>
              <auditorReportTables
                ref="childComp"
                :parent-data-filter="filter"
                :table-data-prop="tableData"
                :pending-by-report="pendingByReport"
                :total-row-prop="total_items"
                @tableAction="handleTableAction"
              />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import auditorReportTables from "./auditorReportTables.vue";
import FilterS2 from "../common/filter-s2.vue";
import { exportMultipleDataLists } from "../common/exportExcel";
import { createLoadingInstance } from "../common/common-tools";
import { ElMessageBox } from "element-plus";
import { useToast } from "vue-toastification";
import {
  addTaskIdtoSessionStorage,
  removeTaskFromSessionStorage,
} from "../common/pollingCeleryTask";
import {
  fetchEqReports,
  refreshEqCache,
  collectTaskIdsFromBundle,
  pollTaskIdsUntilSettled,
  AUDITOR_REPORT_NAMES,
} from "@/services/eqReportsApi";

const SS_AUDITOR_BUNDLE_POLL = "auditorReportsEqBundlePoll";
const SS_AUDITOR_CACHE_REFRESH = "auditorReportsCacheRefresh";

const CACHE_REFRESH_CELERY_POLL_OPTS = {
  intervalMs: 60000,
  maxRounds: 100,
  timeoutMs: 101 * 60 * 1000 + 120000,
};

function emptyAuditorShell() {
  return { data: [], updated_at: "" };
}

export default {
  components: {
    auditorReportTables,
    FilterS2,
  },
  data() {
    return {
      filterButtonOpenClose: false,
      filter: {
        startDate: null,
        endDate: null,
        search: null,
        mp_id: null,
      },
      tableData: {
        client_total: emptyAuditorShell(),
        full_breakdown: emptyAuditorShell(),
        by_state_and_region: emptyAuditorShell(),
        by_state_and_region_and_charger_type: emptyAuditorShell(),
        private_fleet_by_site: emptyAuditorShell(),
        by_state_and_region_1: emptyAuditorShell(),
        by_state_and_region_2: emptyAuditorShell(),
        sd_vista: emptyAuditorShell(),
        project_region_renewable_report: emptyAuditorShell(),
      },
      pendingByReport: AUDITOR_REPORT_NAMES.reduce((acc, k) => {
        acc[k] = false;
        return acc;
      }, {}),
      total_items: 100,
      current_page: 1,
      perPageCount: 100,
      auditorPageLoading: false,
      auditorCacheRefreshInProgress: false,
    };
  },

  mounted() {
    this.$nextTick(async () => {
      this.tryResumeAuditorCacheRefreshPoll();
      await this.tryResumeAuditorBundlePollFromStorage();
    });
  },

  methods: {
    resetPendingByReport() {
      AUDITOR_REPORT_NAMES.forEach((k) => {
        this.pendingByReport[k] = false;
      });
    },

    clearAuditorBundlePollState() {
      try {
        sessionStorage.removeItem(SS_AUDITOR_BUNDLE_POLL);
      } catch (e) {
        /* ignore */
      }
    },

    saveAuditorBundlePollState(params, mpDatesOnly, taskIds, taskIdToReport) {
      try {
        sessionStorage.setItem(
          SS_AUDITOR_BUNDLE_POLL,
          JSON.stringify({
            params: {
              mp_id: params.mp_id,
              start_date: params.start_date ?? null,
              end_date: params.end_date ?? null,
            },
            paramsMode: mpDatesOnly ? "mp_cache" : "custom",
            taskIds,
            taskIdToReport: taskIdToReport || {},
          }),
        );
      } catch (e) {
        console.warn("saveAuditorBundlePollState:", e);
      }
    },

    readAuditorBundlePollState() {
      try {
        const raw = sessionStorage.getItem(SS_AUDITOR_BUNDLE_POLL);
        return raw ? JSON.parse(raw) : null;
      } catch {
        return null;
      }
    },

    bundlePollMatchesCurrentFilter(st, mpDatesOnly) {
      if (!st?.params || !this.filter?.mp_id) {
        return false;
      }
      if (Boolean(mpDatesOnly) !== (st.paramsMode === "mp_cache")) {
        return false;
      }
      if (
        Number(st.params.mp_id) !== Number(this.filter.mp_id)
      ) {
        return false;
      }
      if (!mpDatesOnly) {
        const cur = this.auditorEqParams(mpDatesOnly);
        if (
          String(st.params.start_date || "") !== String(cur.start_date || "") ||
          String(st.params.end_date || "") !== String(cur.end_date || "")
        ) {
          return false;
        }
      }
      return true;
    },

    async tryResumeAuditorBundlePollFromStorage() {
      const st = this.readAuditorBundlePollState();
      if (!st || !Array.isArray(st.taskIds) || st.taskIds.length === 0) {
        return false;
      }
      const mpDatesOnly = st.paramsMode === "mp_cache";
      if (!this.bundlePollMatchesCurrentFilter(st, mpDatesOnly)) {
        this.clearAuditorBundlePollState();
        return false;
      }

      AUDITOR_REPORT_NAMES.forEach((name) => {
        this.pendingByReport[name] = true;
      });

      this.$store.dispatch("tasksProcessing/startLoading", {
        itemKey: "auditor_reports",
        taskId: st.taskIds[0],
        taskType: "reports",
        status: "PENDING",
      });

      const poll = await pollTaskIdsUntilSettled(st.taskIds, {
        intervalMs: 3000,
        timeoutMs: 900000,
      });
      this.clearAuditorBundlePollState();

      if (!poll.ok) {
        this.$store.dispatch("tasksProcessing/failTask", "auditor_reports");
        return false;
      }

      this.applyAuditorTablesFromCeleryPollStatuses(poll.statuses || [], st.taskIdToReport || {});
      this.$store.dispatch("tasksProcessing/completeTask", "auditor_reports");
      return true;
    },

    clearAuditorCacheRefreshState() {
      try {
        sessionStorage.removeItem(SS_AUDITOR_CACHE_REFRESH);
      } catch (e) {
        /* ignore */
      }
    },

    runAuditorCacheRefreshFollowUp(taskId) {
      if (!taskId || this.auditorCacheRefreshInProgress) {
        return;
      }
      this.auditorCacheRefreshInProgress = true;
      pollTaskIdsUntilSettled([taskId], CACHE_REFRESH_CELERY_POLL_OPTS)
        .then((poll) => {
          this.clearAuditorCacheRefreshState();
          try {
            removeTaskFromSessionStorage(taskId);
          } catch (e) {
            /* ignore */
          }
          if (poll.ok) {
            this.$store.dispatch("tasksProcessing/completeTask", "auditor_reports");
            useToast().success(
              "Auditor cache refresh finished. Loading latest monitoring-period data.",
              {
                icon: "fa fa-check",
                position: "bottom-right",
                timeout: 6000,
              },
            );
            if (this.$route?.name === "Dashboard-Auditor-Reports") {
              this.fetchAuditorReports({ mpDatesOnly: true });
            }
          } else {
            this.$store.dispatch("tasksProcessing/failTask", "auditor_reports");
            const hitMaxRounds = (poll.statuses || []).some((s) => s?.result === "max_rounds");
            useToast().error(
              hitMaxRounds
                ? "Auditor cache refresh was still running after 100 checks (about 100 minutes). Try again later."
                : poll.timeout
                  ? "Auditor cache refresh timed out."
                  : "Auditor cache refresh failed.",
              {
                icon: "fa fa-times",
                position: "bottom-right",
                timeout: 6000,
              },
            );
          }
        })
        .catch((e) => {
          console.error("Auditor cache refresh poll:", e);
          this.clearAuditorCacheRefreshState();
          this.$store.dispatch("tasksProcessing/failTask", "auditor_reports");
        })
        .finally(() => {
          this.auditorCacheRefreshInProgress = false;
        });
    },

    tryResumeAuditorCacheRefreshPoll() {
      if (!this.filter?.mp_id) {
        return;
      }
      let st;
      try {
        const raw = sessionStorage.getItem(SS_AUDITOR_CACHE_REFRESH);
        if (!raw) {
          return;
        }
        st = JSON.parse(raw);
      } catch {
        this.clearAuditorCacheRefreshState();
        return;
      }
      if (!st?.taskId) {
        return;
      }
      if (
        Number(st.mp_id) !== Number(this.filter.mp_id)
      ) {
        return;
      }
      this.$store.dispatch("tasksProcessing/startLoading", {
        itemKey: "auditor_reports",
        taskId: st.taskId,
        taskType: "reports",
        status: "PENDING",
      });
      this.runAuditorCacheRefreshFollowUp(st.taskId);
    },

    applyAuditorBundlePayload(payload) {
      this.resetPendingByReport();
      const rows = Array.isArray(payload?.reports) ? payload.reports : [];
      const byName = Object.fromEntries(rows.map((r) => [r.report_name, r]));

      AUDITOR_REPORT_NAMES.forEach((name) => {
        const row = byName[name];
        if (!row) {
          this.tableData[name] = emptyAuditorShell();
          return;
        }
        if (String(row.status).toUpperCase() === "PENDING") {
          this.pendingByReport[name] = true;
          const d = row.data && typeof row.data === "object" ? row.data : {};
          const rawResult = d.result;
          let dataArr = [];
          if (Array.isArray(rawResult)) {
            dataArr = rawResult;
          } else if (rawResult != null && typeof rawResult === "object") {
            dataArr = [rawResult];
          }
          this.tableData[name] = {
            data: dataArr,
            updated_at: d.updated_at || "",
          };
          return;
        }
        if (String(row.status).toUpperCase() === "SUCCESS") {
          const d = row.data && typeof row.data === "object" ? row.data : {};
          let result = d.result;
          if (!Array.isArray(result)) {
            result = result == null ? [] : [result];
          }
          this.tableData[name] = {
            data: result,
            updated_at: d.updated_at || "",
          };
          return;
        }
        this.tableData[name] = emptyAuditorShell();
      });
    },

    buildTaskIdToReportNameFromBundle(payload) {
      const map = {};
      const reports = payload?.reports || [];
      for (const r of reports) {
        if (r?.task_id && r?.report_name) {
          map[r.task_id] = r.report_name;
        }
      }
      const topIds = Array.isArray(payload?.task_ids) ? payload.task_ids : [];
      if (Object.keys(map).length === 0 && topIds.length > 0 && reports.length > 0) {
        topIds.forEach((id, i) => {
          const r = reports[i];
          if (id && r?.report_name) {
            map[id] = r.report_name;
          }
        });
      }
      return map;
    },

    applyAuditorTablesFromCeleryPollStatuses(statuses, taskIdToReport) {
      const map = taskIdToReport || {};
      const extract = (raw) => {
        if (raw == null || raw === "hasResult") {
          return null;
        }
        if (Array.isArray(raw)) {
          return { data: raw, updated_at: "" };
        }
        if (typeof raw === "object") {
          if (Array.isArray(raw.result)) {
            return { data: raw.result, updated_at: raw.updated_at || "" };
          }
          if (Array.isArray(raw.data)) {
            return { data: raw.data, updated_at: raw.updated_at || "" };
          }
          const d = raw.data;
          if (d && typeof d === "object" && Array.isArray(d.result)) {
            return { data: d.result, updated_at: d.updated_at || "" };
          }
        }
        return null;
      };

      for (const s of statuses || []) {
        const tid = s?.task_id;
        const reportName = map[tid];
        if (!reportName || !AUDITOR_REPORT_NAMES.includes(reportName)) {
          continue;
        }
        const extracted = extract(s?.result);
        if (!extracted) {
          continue;
        }
        this.tableData[reportName] = extracted;
        this.pendingByReport[reportName] = false;
      }
      AUDITOR_REPORT_NAMES.forEach((name) => {
        this.pendingByReport[name] = false;
      });
    },

    auditorEqParams(mpDatesOnly) {
      const params = {
        mp_id: this.filter.mp_id,
      };
      const useCustomRange =
        !mpDatesOnly &&
        this.filter.hasCustomDate === true &&
        this.filter.startDate &&
        this.filter.endDate;
      if (useCustomRange) {
        params.start_date = this.filter.startDate;
        params.end_date = this.filter.endDate;
      }
      return params;
    },

    filterHandle(event) {
      this.filter = event;
      this.fetchAuditorReports();
    },

    buttonOpenClosehandle(event) {
      this.filterButtonOpenClose = event;
    },

    async fetchAuditorReports(options = {}) {
      const mpDatesOnly = options.mpDatesOnly === true;

      this.$store.dispatch("tasksProcessing/clearLoadingState", "auditor_reports");

      if (!this.filter.mp_id) {
        return;
      }

      const params = this.auditorEqParams(mpDatesOnly);

      try {
        this.auditorPageLoading = false;
        if (await this.tryResumeAuditorBundlePollFromStorage()) {
          return;
        }

        this.auditorPageLoading = true;
        let payload;
        try {
          payload = await fetchEqReports("auditor", params);
        } catch (error) {
          const msg =
            error?.response?.data?.message ||
            error?.message ||
            "Failed to load auditor reports.";
          console.error("Error fetching bundled auditor reports:", error);
          await ElMessageBox.alert(
            `<span class="moderat-meRed">${msg}</span>`,
            "Error",
            { confirmButtonText: "OK", dangerouslyUseHTMLString: true },
          ).catch(() => {});
          return;
        }

        this.applyAuditorBundlePayload(payload);
        const taskIds = collectTaskIdsFromBundle(payload);

        if (taskIds.length === 0) {
          return;
        }

        this.auditorPageLoading = false;

        this.saveAuditorBundlePollState(
          params,
          mpDatesOnly,
          taskIds,
          this.buildTaskIdToReportNameFromBundle(payload),
        );

        this.$store.dispatch("tasksProcessing/startLoading", {
          itemKey: "auditor_reports",
          taskId: taskIds[0],
          taskType: "reports",
          status: "PENDING",
        });

        const poll = await pollTaskIdsUntilSettled(taskIds, {
          intervalMs: 3000,
          timeoutMs: 900000,
        });

        this.clearAuditorBundlePollState();

        if (!poll.ok) {
          const detail = poll.timeout ? "Timed out waiting for reports." : "One or more tasks failed.";
          console.error("Auditor report task polling:", detail, poll);
          this.$store.dispatch("tasksProcessing/failTask", "auditor_reports");
          await ElMessageBox.alert(
            `<span class="moderat-meRed">${detail}</span>`,
            "Reports",
            { confirmButtonText: "OK", dangerouslyUseHTMLString: true },
          ).catch(() => {});
          return;
        }

        const taskIdToReport = this.buildTaskIdToReportNameFromBundle(payload);
        this.applyAuditorTablesFromCeleryPollStatuses(poll.statuses || [], taskIdToReport);
        this.$store.dispatch("tasksProcessing/completeTask", "auditor_reports");
      } finally {
        this.auditorPageLoading = false;
      }
    },

    unwrapAuditorRows(val) {
      if (val && typeof val === "object" && Array.isArray(val.data)) {
        return val.data;
      }
      if (val && typeof val === "object" && Array.isArray(val.result)) {
        return val.result;
      }
      if (Array.isArray(val)) {
        return val;
      }
      return [];
    },

    async handleExportFile() {
      const loading = createLoadingInstance();

      try {
        const dataToExport = {
          client_total: this.unwrapAuditorRows(this.tableData.client_total),
          full_breakdown: this.unwrapAuditorRows(this.tableData.full_breakdown),
          by_state_and_region: this.unwrapAuditorRows(this.tableData.by_state_and_region),
          by_state_and_region_and_charger_type: this.unwrapAuditorRows(
            this.tableData.by_state_and_region_and_charger_type,
          ),
          private_fleet_by_site: this.unwrapAuditorRows(this.tableData.private_fleet_by_site),
          by_state_and_region_1: this.unwrapAuditorRows(this.tableData.by_state_and_region_1),
          by_state_and_region_2: this.unwrapAuditorRows(this.tableData.by_state_and_region_2),
          sd_vista: this.unwrapAuditorRows(this.tableData.sd_vista),
          project_region_renewable_report: this.unwrapAuditorRows(
            this.tableData.project_region_renewable_report,
          ),
        };

        const hasData = Object.values(dataToExport).some(
          (table) => Array.isArray(table) && table.length > 0,
        );
        if (!hasData) {
          console.log("No data available for any report type.");
          loading.close();
          return;
        }

        const tableNames = {
          client_total: "Client Total",
          full_breakdown: "Full Breakdown",
          by_state_and_region: "By State and Region",
          by_state_and_region_and_charger_type: "State, Region, Charger",
          private_fleet_by_site: "Private Fleet by Site",
          by_state_and_region_1: "By State Region One",
          by_state_and_region_2: "By State Region Two",
          sd_vista: "SD Vista",
          project_region_renewable_report: "Project Region Renewable Report",
        };

        const skipKeysList = {
          client_total: [],
          full_breakdown: ["afec", "mpg", "energy_delivered", "improvement_factor", "fuel_emission_factor"],
          by_state_and_region: [],
          by_state_and_region_and_charger_type: [],
          private_fleet_by_site: [],
          by_state_and_region_1: [],
          by_state_and_region_2: [],
          sd_vista: [],
          project_region_renewable_report: [],
        };

        try {
          await exportMultipleDataLists({
            title: "Auditor Report",
            tableData: dataToExport,
            tableNames,
            skipKeysList,
            fileName: "AuditorReport.xlsx",
          });
          loading.close();
          console.log("Excel file generated successfully!");
        } catch (error) {
          loading.close();
          console.error("Error generating Excel file:", error.message);
        }
      } catch (error) {
        loading.close();
        console.error("Error exporting file:", error.message);
      }
    },

    async handleClearCache() {
      AUDITOR_REPORT_NAMES.forEach((k) => {
        this.tableData[k] = emptyAuditorShell();
      });
      this.resetPendingByReport();

      if (!this.filter.mp_id) {
        await ElMessageBox.alert(
          `<span class="moderat-meRed">Select a monitoring period and project first.</span>`,
          "Refresh cache",
          { confirmButtonText: "OK", dangerouslyUseHTMLString: true },
        ).catch(() => {});
        return;
      }

      try {
        const body = { mp_id: this.filter.mp_id};
        const data = await refreshEqCache("auditor", body);
        const taskId = data.task_id;

        if (taskId) {
          try {
            sessionStorage.setItem(
              SS_AUDITOR_CACHE_REFRESH,
              JSON.stringify({
                taskId,
                mp_id: this.filter.mp_id,
              }),
            );
          } catch (e) {
            console.warn("cache refresh sessionStorage:", e);
          }

          addTaskIdtoSessionStorage("auditor_reports", taskId, "PENDING", "message", {
            success_message: "Auditor equation cache refresh finished.",
            error_message: "Auditor equation cache refresh failed.",
          });

          this.runAuditorCacheRefreshFollowUp(taskId);
        } else {
          await this.fetchAuditorReports({ mpDatesOnly: true });
          await ElMessageBox.alert(
            `<span class="moderat-meGreen">Cache refresh completed. Showing cached monitoring-period data.</span><br/>`,
            "Refresh cache",
            { confirmButtonText: "OK", type: "success", dangerouslyUseHTMLString: true },
          ).catch(() => {});
        }
      } catch (error) {
        const msg = error?.response?.data?.message || error?.message || "Cache refresh failed.";
        console.error("Error clearing cache:", error);
        await ElMessageBox.alert(
          `<span class="moderat-meRed">${msg}</span>`,
          "Refresh cache",
          { confirmButtonText: "OK", dangerouslyUseHTMLString: true },
        ).catch(() => {});
      }
    },

    handleTableAction(event) {
      if (event.kind === "changePage") {
        this.current_page = event.index;
        this.handleReload();
      } else if (event.kind === "perPageChange") {
        this.current_page = 1;
        this.perPageCount = event.index;
        this.handleReload();
      }
    },

    handleReload() {
      this.fetchAuditorReports();
    },
  },
};
</script>